export default {
  data () {
    return {}
  },
  methods: {
    findEvent (arg) {
      let { e, list = this.funcList, name = this.name, eventName = "change" } = arg
      let item = list.find(r =>
        r.eventName == eventName + '-' + name
      )
      if (item) return item.func(e, this.modelList[this.name])
    }
  }
}